import * as Types from '../types/types.generated';

import { gql } from '@apollo/client';
import { AttachmentFieldsFragmentDoc } from './attachmentFields.generated';
import { KeywordTagFieldsFragmentDoc } from './keywordTagFields.generated';
export type RequirementFieldsToAssignRequirementFragment = { __typename?: 'Requirement', id: string, name: string, requirementId?: string | null, status: Types.RequirementStatus, category: Types.RequirementCategory, modifiedAt?: any | null, version?: string | null, definition?: string | null, createdBy: { __typename?: 'User', id: string, name: string }, modifiedBy: { __typename?: 'User', id: string, name: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, activeTypeMarkets: Array<{ __typename?: 'ActiveTypeMarket', id: string, name: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, systemLevels: Array<{ __typename?: 'SystemLevel', id: string, name: string }> };

export const RequirementFieldsToAssignRequirementFragmentDoc = gql`
    fragment RequirementFieldsToAssignRequirement on Requirement {
  id
  name
  requirementId
  status
  category
  createdBy {
    id
    name
  }
  modifiedAt
  version
  modifiedBy {
    id
    name
  }
  tags {
    id
    name
  }
  attachments {
    ...AttachmentFields
  }
  keywords {
    ...KeywordTagFields
  }
  vexClusters {
    id
    name
  }
  activeTypeMarkets {
    id
    name
  }
  definition
  version
  markets {
    id
    name
  }
  systemLevels {
    id
    name
  }
}
    ${AttachmentFieldsFragmentDoc}
${KeywordTagFieldsFragmentDoc}`;